import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5671b750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: "",
  hidden: ""
}, "กรุณาเลือกประเภทโครงการ", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form-label text-muted"
}, " รายละเอียด: ", -1))
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: "name",
        class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.name}])
      }, " ชื่อโครงการ: ", 2),
      (_ctx.submited && _ctx.errors.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " * กรุณาป้อนชื่อโครงการ "))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectForm.name) = $event)),
        class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.name}]),
        placeholder: "กรุณาป้อนชื่อโครงการ...",
        "aria-label": "name",
        autocomplete: "off",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
      }, null, 34), [
        [
          _vModelText,
          _ctx.projectForm.name,
          void 0,
          { trim: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        for: "projectTypeId",
        class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.projectTypeId}])
      }, " ประเภทโครงการ: ", 2),
      (_ctx.submited && _ctx.errors.projectTypeId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาเลือกประเภทโครงการ "))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.projectForm.projectTypeId) = $event)),
        class: _normalizeClass(["form-select", {'is-invalid': _ctx.submited && _ctx.errors.projectTypeId}]),
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args))),
        "aria-label": "projectType"
      }, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectTypes, (projectType, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: projectType.id
          }, _toDisplayString(projectType.name), 9, _hoisted_6))
        }), 128))
      ], 34), [
        [
          _vModelSelect,
          _ctx.projectForm.projectTypeId,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_ctx.submited && _ctx.errors.remark)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " * กรุณาป้อนรายละเอียด "))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("textarea", {
        class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.description}]),
        placeholder: "กรุณาป้อนรายละเอียด...",
        "aria-label": "description",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.projectForm.description) = $event)),
        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
      }, "\n    ", 34), [
        [_vModelText, _ctx.projectForm.description]
      ])
    ])
  ], 64))
}